import Component from './Component';
import Modal from './Modal';
/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */


/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */

export default class BackAlert extends Component {

    decorator() {
        return {
            selector: '.js-back-alert',
            name: 'BackAlert',
        }
    }

    constructor(element) {
        super(element);
        this.bind();
    }

    bind() {
        let $el = $(this.element);

        if (window.history && history.pushState) {
            $(window).ready(function() {
                if(document.referrer.match(/^(.*)\/application\/(.*)\/overview(\/*)$/g)) {
                    let modal = Modal.get(0);
                    if(!modal) {
                        modal = Modal.bindElement(document.querySelector('.js-modal'));
                    }
                    history.pushState(null, null, null);
                    $(window).off().on('popstate', function(e) {
                        modal.open('back-alert-template', function() {
                            $(modal.$content).find('.js-back-alert-msg').text($el.data('confirm-message'));
                            $(modal.$content).find('.js-back-alert-yes').off().on('click', function() {
                                modal.close();
                                window.location = document.referrer;
                                // history.go(-1); // dont remove, as alternative
                            });
                            $(modal.$content).find('.js-back-alert-no').off().on('click', function() {
                                modal.close();
                                history.pushState(null, null, null);
                            });
                        });
                    });
                }
            });
        }
    }

}
